<template>
  <div v-bind:id="`accept-` + job.job_id" class="position-relative sd-job-card">
    <div class="sd-job-item" :class="job.is_declined ? 'declined' : ''">
      <div class="job-item-top">
        <div v-if="parseInt(job.percentage) && !this.applied && this.user.sub_branch != '2'" class="match_percentage" >
          {{ parseInt(job.percentage) }}% match
        </div>
        <div v-else-if="parseInt(job.percentage) && this.applied" class="match_percentage recent">
          Uitgenodigd
        </div>
        <div v-if="parseInt(job.is_declined)" class="declined">Afgewezen</div>
        <div v-else-if="parseInt(job.is_interested)" class="bell">
          <svg-icon icon="notification_bell" />
        </div>
      </div>
      <router-link
        :to="{
          name: routeName,
          params: params
        }"

        :class="this.closed? 'closed' : ''"
      >
        <div class="job-item-content">
          <ul class="text location">
            <template v-if="this.user.sub_branch == '2' || (this.user.sub_branch == '1' && job.duration_type == 1)">
              <li><strong>Start: {{ getFirstWorkingDate() }} </strong> <span class="duration_type recent_yellow" v-if="job.sub_branch == '1' && job.duration_type == 1 && job.hired_dates == null">Langdurig</span></li>
              <li><strong>Eind: {{ getLastWorkingDate() }}</strong></li>
            </template>
            <template v-if="this.user.sub_branch == '1' && job.duration_type == 0 && job.hired_dates == null">
              <li><strong>Start: {{ subtitle[0] }} </strong> <span v-if="job.hired_dates == null" class="duration_type recent">{{ subtitle[1] }}</span></li>
            </template>
            <template v-else-if="this.user.sub_branch == '1' && job.duration_type == 0 && job.hired_dates != null">
              <li><strong>Start: {{ subtitle[0] }} </strong></li>
            </template>
            <template v-if="job.sub_branch == '1'">
              <li v-if="formattedAudience">Groep {{ formattedAudience }}</li>
            </template>
            <template v-if="job.sub_branch == '2'">
              <li>{{ job.subject }}, {{ formattedGroup }}</li>
              <li v-if="formattedAudience">{{ formattedAudience }} klas</li>
            </template>
            <template v-if="user.type == 1">
              <li v-if="!overview_type && job.city">{{ job.city }}</li>
              <li v-if="overview_type === 'list' && job.city">{{ job.name_location }} ({{ job.city }})</li>
            </template>
            <template v-if="user.type == 2 && Object.keys(user.addresses).length > 1">
              <li v-if="!overview_type && job.city">{{ job.name_location }} ({{ job.city }})</li>
              <li v-if="overview_type === 'list' && job.city">{{ job.name_location }} ({{ job.city }})  </li>
            </template>
          </ul>
          <div v-if="user.type == 2 && this.applicant" class="applicant-overview">
            <div v-for="(applicant, index) in job.applicants" :key="index" v-if="index < 4" class="applicant">
              <span class="applicant-avatar">
                <img v-if="applicant.avatar" :src="applicant.avatar" />
                <svg-icon v-else icon="person_male" />
              </span>
            </div>
            <div v-if="job.applicants.length > 4" class="applicant"><span class="applicant-avatar">+{{ job.applicants.length - 4 }}</span></div>
          </div>
          <div v-if="user.type === 2 && this.recommended" class="applicant-overview">
            <div v-for="(matches, index) in job.matches" :key="index" v-if="index < 4" class="applicant">
              <span class="applicant-avatar">
                <img v-if="matches.avatar" :src="matches.avatar" />
                <svg-icon v-else icon="person_male" />
              </span>
            </div>
            <div v-if="job.matches.length > 4" class="applicant"><span class="applicant-avatar">+{{ job.matches.length - 4 }}</span></div>
          </div>
          <div v-if="user.type == 2 && this.closed" class="applicant-overview">
            <span><img :src="job.applicant_avatar" class="applicant-avatar"/></span>
            <span class="applicant-name">{{ job.applicant_firstname }}</span>
<!--            <span v-if="job.applicant_achievements" class="applicant-achievements"><svg-icon icon="achievement" /> {{ job.applicant_achievements.length }} achievement{{ job.applicant_achievements.length > 1 ? 's' : '' }}</span>-->
          </div>
        </div>
        <div v-if="overview_type === 'list' && user.type == 2" class="job-item-button">Meer info</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      user: null,
      city: null,
      applicants: null,
      subtitle: [],
      formattedAudience: null,
      formattedGroup: null,
      routeName: 'job',
      params: {}
    };
  },
  props: {
    job: Object,
    job_ids: Array,
    all_jobs: Array,
    overview_type: String,
    apply: Boolean,
    view: Boolean,
    arrow: Boolean,
    match: Boolean,
    recommended: Boolean,
    accept: Boolean,
    applied: Boolean,
    interested: Boolean,
    applicant: Boolean,
    highlight: Boolean,
    closed: Boolean
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    job: {
      immediate: true,
      deep: true,
      handler() {
        this.user = JSON.parse(localStorage.getItem("user"));

        if(this.job.job_id)
        {
          this.params["id"] = this.job.job_id;
        }

        if(this.job.id)
        {
          this.params["id"] = this.job.id;
        }

        if(this.job_ids)
        {
          this.params["job_ids"] = this.job_ids;
        }

        if(this.all_jobs && this.all_jobs.length > 1)
        {
          this.params["job_ids"] = this.all_jobs.map(({ job_id }) => job_id);
        }

        if(this.recommended)
        {
          if(this.user.type == 2)
          {
            this.routeName = 'job-matches';
            this.params["id"] = parseInt(this.params["id"]);
          }
          else
          {
            this.params["matched_job_id"] = parseInt(this.params["id"]);
            this.params["action"] = "apply";
          }
        }
        else if(this.match)
        {
          if(this.job.is_interested)
            this.params["action"] = "interested";
          else
            this.params["action"] = "apply";
        }
        else if(this.accept)
        {
          this.params["action"] = "accept";
          this.params["matched_applicant_id"] = parseInt(this.job.matched_applicant_id);
        }
        else if(this.applied)
        {
          if(this.job.is_declined)
            this.params["action"] = "declined";
          else if(this.job.is_interested)
            this.params["action"] = "interested";
          else
            this.params["action"] = "applied";
        }
        else if(this.closed)
          this.params["action"] = "closed";
        else if(this.arrow)
          this.params["action"] = "view";
        else if(!this.params["action"])
          this.params["action"] = "view";
        else if(!this.params["applicants"])
        {
          this.routeName = 'job-applicants'
          this.params["action"] = "applicants";
        }
        
        // Calculate subtitle based on job data
        if (this.job.working_dates || this.job.hired_dates) {
          try {
            let working_dates = this.job.hired_dates
                ? JSON.parse(this.job.hired_dates)
                : JSON.parse(JSON.parse(this.job.working_dates));

            let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
            let _subtitle = "";
            let locationType = "";

            if(this.overview_type !== 'list')
            {
              if(Object.keys(working_dates).length > 1)
                _subtitle = [formatedFirstDate, Object.keys(working_dates).length + " dagen" + locationType];
              else
                _subtitle = [formatedFirstDate, "één dag" + locationType];
            }
            else {
              _subtitle = [formatedFirstDate];
            }

            this.subtitle = _subtitle;
          } catch (error) {
            console.error('Error parsing working_dates:', error);
          }
        }

        if(this.job.subject)
        {
          try {
            let match = this.job.subject.match(/\((.*?)\)/);

            if(match)
              this.job.subject = match[1];
          } catch (error) {
            console.error('Error parsing job.subject:', error);
          }
        }

        if(this.job.audience != null) {
          try {
            this.formattedAudience = JSON.parse(this.job.audience).join(', ');
          } catch(error) {
            console.log('job.audience is not JSON');
            this.formattedAudience = this.job.audience;
          }
        }

        if(this.job.group != null) {
          try {
            this.formattedGroup = JSON.parse(this.job.group).join(', ');
          } catch(error) {
            this.formattedGroup = this.job.group;
          }
        }
      }
    }
  },
  methods: {
    async fetchData() {
      // compute applicants??? Bekijk aanbevelingen
      if (this.job.id) {
        // var user = JSON.parse(localStorage.getItem("user"));
        // var ID = parseInt(this.job.id);
        // if company
        // if (user.type == 2) {
        // this.view = true;
        // this.applicants = await this.getTokenAPIList("applicants/" + ID);
        // this.applicants = await this.getTokenAPIList("applicants/" + ID);
        // }
      }
    },
    getFirstWorkingDate() {
      let working_dates = this.job.hired_dates
          ? JSON.parse(this.job.hired_dates)
          : JSON.parse(JSON.parse(this.job.working_dates));
      return new Date(Object.keys(working_dates)[0]).toLocaleDateString();
    },
    getLastWorkingDate() {
      let working_dates = this.job.hired_dates
          ? JSON.parse(this.job.hired_dates)
          : JSON.parse(JSON.parse(this.job.working_dates));
      return new Date(Object.keys(working_dates)[Object.keys(working_dates).length - 1]).toLocaleDateString();
    },
    async onAccept(id) {
      this.$store.state.loading = true;
      await this.acceptJob(id);
      // continue if it was accepted
      window.scrollTo(0, 0);
      this.$emit("input", "accepted"); // fullscreen_notif
    }
  }
};
</script>

<style scoped>
.sd-job-item a {
  display: block;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
  background-color: #FFF;
  color: #64513D;
  padding: 15px;
  margin-right: 15px;
}

.sd-job-item.declined {
  filter: grayscale(1);
}

.sd-job-item.declined .job-item-top .declined {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 0px;
  font-weight: 400;
  height: 25px;
  width: 85px;
  background-color: #F6F6F6;
}

.sd-job-item .job-item-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.sd-job-item .job-item-top {
  position: absolute;
  top: -10px;
  left: 15px;
  right: 30px;
  display: flex;
  justify-content: space-between;
}

.sd-job-item .match_percentage {
  background-color: #FFCD00;
  border-radius: 10px;
  font-weight: 400;
  font-size: 12px;
  padding: 3px 15px;
  margin-right: 5px;
}

.sd-job-item .match_percentage.recent {
  height: 25px;
  background-color: #F6F6F6;
}

.sd-job-item .duration_type {
  border-radius: 10px;
  font-size: 12px;
  padding: 3px 15px;
  margin-left: 5px;
}

.sd-job-item .duration_type.recent {
  height: 25px;
  background-color: #F6F6F6;
}

.sd-job-item .duration_type.recent_yellow {
  height: 25px;
  background-color: #FFF9E2;
}

.sd-job-item .bell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 5px;
  background-color: #FFF;
}

/deep/.sd-job-item .bell svg {
  width: 15px;
  height: 15px;
}

.sd-job-item .text.location {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 12px;
}

.sd-job-item .applicant-overview {
  display: flex;
  align-items: center;
  margin-top: 15px;
  gap: unset;
}

.sd-job-item .applicant-overview span:not(:last-child) {
  margin-right: 15px;
}

.sd-job-item .applicant-overview .applicant:not(:last-child) {
  margin-right: 5px;
}

.sd-job-item .applicant-overview .applicant .applicant-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6F6F6;
}

.sd-job-item .applicant-overview .applicant .applicant-avatar img,
/deep/.sd-job-item .applicant-overview .applicant .applicant-avatar svg {
  height: 100%;
  width: 100%;
  border-radius: 100%;
  object-fit: cover;
}

.sd-job-item .applicant-overview .applicant-avatar {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.sd-job-item .applicant-overview .applicant-achievements {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #64513D;
}

/deep/.sd-job-item .applicant-overview .svg-container svg {
  height: 15px;
  color: #FFCD00;
}
</style>
